export default __webpack_public_path__ + "static/media/heat-7.6b29c9e5.png";